import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledBoundlessBenefitsBanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--general-spacer-03, ${toRem(16)});
  padding: var(--general-spacer-04, ${toRem(24)});
  border: ${toRem(1)} solid ${baseVariables.color['neutral20']};
  border-radius: var(--t-cards-border-radius, ${toRem(14)});
  background-color: ${baseVariables.color['base0']};
  overflow: hidden;

  @media ${baseVariables.mediaQuery.md} {
    flex-direction: row;
    align-items: stretch;
    gap: 0;
    padding: 0;
  }

  .wallet-boundless-benefits-banner__image-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 100%;
    max-width: ${toRem(280)};
    margin: 0 auto;
    background-color: ${baseVariables.color['base0']};

    @media ${baseVariables.mediaQuery.md} {
      width: auto;
      max-width: none;
      margin: 0;
      align-self: stretch;
      padding: var(--general-spacer-03, ${toRem(16)});
    }
  }

  .wallet-boundless-benefits-banner__image {
    display: block;
    width: 100%;
    max-width: ${toRem(220)};
    height: auto;
    border: ${toRem(1)} solid ${baseVariables.color['neutral20']};
    border-radius: var(--t-cards-border-radius, ${toRem(14)});
    background-color: ${baseVariables.color['base0']};
    box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
  }

  .wallet-boundless-benefits-banner__content {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-areas:
      'heading'
      'cta'
      'benefits';
    gap: var(--general-spacer-03, ${toRem(16)});
    min-width: 0;

    @media ${baseVariables.mediaQuery.md} {
      flex: 1;
      grid-template-columns: 1fr auto;
      grid-template-areas:
        'heading cta'
        'benefits benefits';
      align-items: center;
      padding: var(--general-spacer-04, ${toRem(24)});
    }
  }

  .wallet-boundless-benefits-banner__heading {
    grid-area: heading;
    margin: 0;
    align-self: center;
  }

  .wallet-boundless-benefits-banner__benefits {
    grid-area: benefits;
    display: flex;
    flex-direction: column;
    gap: var(--general-spacer-03, ${toRem(16)});
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .wallet-boundless-benefits-banner__cta.m-link-tertiary-button,
  .wallet-boundless-benefits-banner__cta.m-link-tertiary-button-external {
    grid-area: cta;
    justify-self: start;
    align-self: center;

    @media ${baseVariables.mediaQuery.md} {
      justify-self: end;
    }
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    margin-right: 0;
    white-space: nowrap;
    color: var(--Color-Set-button-tertiary-color, var(--t-button-tertiary-color, ${baseVariables.color['base10']}));
    text-align: center;
    text-decoration: none;

    &:hover,
    &:focus,
    &:focus-visible {
      font-weight: 500;
      text-decoration: none;
      border-bottom-color: transparent;
    }

    &::after {
      position: static;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: ${toRem(16)};
      height: ${toRem(16)};
      padding-left: var(--general-spacer-02, ${toRem(8)});
      font-size: ${toRem(16)};
      line-height: 1;
      vertical-align: middle;
    }
  }

  .wallet-boundless-benefits-banner__benefit {
    display: flex;
    align-items: flex-start;
    gap: var(--general-spacer-03, ${toRem(16)});
  }

  .wallet-boundless-benefits-banner__multiplier {
    display: flex;
    width: ${toRem(40)};
    height: ${toRem(40)};
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--general-spacer-01, ${toRem(4)});
    aspect-ratio: 1 / 1;
    flex-shrink: 0;
    border-radius: ${toRem(8)};
    border: ${toRem(1)} solid ${baseVariables.color['neutral20']};
    background-color: ${baseVariables.color['base0']};
    overflow: hidden;
  }

  .wallet-boundless-benefits-banner__multiplier-value {
    max-width: 100%;
    overflow: hidden;
    color: var(--t-brand-fg-color, ${baseVariables.color['base10']});
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .wallet-boundless-benefits-banner__multiplier-accent {
    display: block;
    width: ${toRem(16)};
    height: ${toRem(3)};
    flex-shrink: 0;
    background-color: ${baseVariables.color['accent10']};
  }

  .wallet-boundless-benefits-banner__description {
    flex: 1;
    min-width: 0;
    color: var(--t-brand-fg-color, ${baseVariables.color['base10']});
  }
`;
